<template>
  <b-modal
    id="modal-add-zone-delivery-rate"
    ref="modal"
    title="Add New Zone Delivery Rate"
    no-close-on-backdrop
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-variant="primary primary-btn"
    ok-title="Add"
    cancel-title="Close"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        label="Name"
        label-for="name"
        invalid-feedback="Name is required"
        valid-feedback="Look Good"
      >
        <b-form-input
          id="name"
          v-model="name"
          readonly
          :state="validateName"
          @keyup="keyupValidationName"
          required
        ></b-form-input>
        <p v-if="(isHidden = this.zoneModel ? false : true)" class="text-info">
          * Fill the zone and delivery rate fields below to generate name.
        </p>
      </b-form-group>
      <b-form-group
        label="Province"
        label-for="province"
        invalid-feedback="Choose a Province"
      >
        <v-select
          id="province"
          :options="provinceOptions"
          placeholder="choose..."
          v-model="provinceModel"
          :clearable="true"
          :class="validateProvince"
          @input="provinceSelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!provinceModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        label="Region"
        label-for="region"
        invalid-feedback="Choose a Region"
      >
        <v-select
          id="region"
          :options="regionOptions"
          placeholder="choose..."
          v-model="regionModel"
          :clearable="true"
          :class="validateRegion"
          @input="regionSelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!regionModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        label="Zone"
        label-for="zone"
        invalid-feedback="Choose a Zone"
      >
        <v-select
          id="zone"
          :options="zoneOptions"
          placeholder="choose..."
          v-model="zoneModel"
          :clearable="true"
          :class="validateZone"
          @input="zoneSelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!zoneModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        label="displayText"
        label-for="displayText"
        invalid-feedback="Input a DeliveryRate"
      >
        <b-form-input
          id="displayText"
          v-model="displayText"
          @input="deliveryRateSelectedValue($event)"
        ></b-form-input>
      </b-form-group>
      <b-form-group label-for="deliveryRate" invalid-feedback="Choose a Rate">
        <v-select
          id="rate"
          :options="rateOptions"
          placeholder="choose..."
          v-model="rate"
          @input="rateSelectedValue($event)"
        />
      </b-form-group>
      <b-form-group
        label="ApplicableStartTime"
        label-for="applicableStartTime"
        invalid-feedback=""
      >
        <b-form-timepicker
          id="applicableStartTime"
          reset-button
          v-model="applicableStartTime"
          locale="en"
        ></b-form-timepicker>
        {{ applicableStartTime }}
      </b-form-group>
      <b-form-group
        label="ApplicableEndTime"
        label-for="applicableEndTime"
        invalid-feedback=""
      >
        <b-form-timepicker
          id="applicableEndTime"
          reset-button
          v-model="applicableEndTime"
          locale="en"
        ></b-form-timepicker>
        {{ applicableEndTime }}
      </b-form-group>
      <b-form-group
        label="ApplicableDate"
        label-for="applicableDate"
        invalid-feedback=""
      >
        <v-select
          id="applicableDate"
          :options="applicableDateOptions"
          placeholder="choose..."
          v-model="applicableDateModel"
          :clearable="true"
          :class="validateApplicableDate"
          @input="applicableDateSelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!applicableDateModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        label="IsSameDayOnly"
        label-for="isSameDayOnly"
        invalid-feedback="Choose IsSameDayOnly"
      >
        <v-select
          id="isSameDayOnly"
          :options="isSameDayOnlyOptions"
          placeholder="choose..."
          v-model="isSameDayOnlyModel"
          :clearable="true"
          :class="validateZone"
          @input="isSameDayOnlySelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!isSameDayOnlyModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
        label="Days of Week"
        label-for="daysOfWeek"
        invalid-feedback="Choose Days of Week"
      >
        <v-select
          id="daysOfWeek"
          :options="daysOfWeekOptions"
          placeholder="choose..."
          v-model="daysOfWeekModel"
          :clearable="true"
          :class="validateDaysOfWeek"
          @input="daysOfWeekSelectedValue($event)"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search"
              :required="!daysOfWeekModel"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
    </form>
  </b-modal>
</template>
<script>
import Vue from "vue";
import ModalMixin from "@/mixin/modal-mixin";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

export default {
  mixins: [ModalMixin],
  props: [
    "zoneOptions",
    "deliveryRateOptions",
    "provinceOptions",
    "regionOptions"
  ],
  name: "add-region-popup",
  data() {
    return {
      validateName: null,
      validateProvince: "",
      validateRegion: "",
      validateZone: "",
      validateDeliveryRate: "",
      validateApplicableDate: "",
      validateDaysOfWeek: "",

      provinceModel: "",
      regionModel: "",
      zoneModel: "",
      displayText: "Anytime (8am - 8pm)",
      rate: "$10",
      applicableStartTime: null,
      applicableEndTime: null,
      applicableDateModel: { value: 1, label: "1" },
      isSameDayOnlyModel: { value: false, label: "false" },
      daysOfWeekModel: { value: "1,2,3,4,5", label: "Weekdays" },

      applicableDateOptions: [
        { value: 0, label: "0" },
        { value: 1, label: "1" }
      ],

      isSameDayOnlyOptions: [
        { value: true, label: "true" },
        { value: false, label: "false" }
      ],
      daysOfWeekOptions: [
        { value: "1,2,3,4,5", label: "Weekdays" },
        { value: "6,0", label: "Weekends" },
        { value: "1,2,3,4,5,6,0", label: "All Days" }
      ],
      rateOptions: [
        "$0",
        "$1",
        "$2",
        "$3",
        "$4",
        "$5",
        "$6",
        "$7",
        "$8",
        "$9",
        "$10",
        "$11",
        "$12",
        "$13",
        "$14",
        "$15",
        "$16",
        "$17",
        "$18",
        "$19",
        "$20",
        "$21",
        "$22",
        "$23",
        "$24",
        "$25",
        "$26",
        "$27",
        "$28",
        "$29",
        "$30",
        "$31",
        "$32",
        "$33",
        "$34",
        "$35",
        "$36",
        "$37",
        "$38",
        "$39",
        "$40",
        "$41",
        "$42",
        "$43",
        "$44",
        "$45",
        "$46",
        "$47",
        "$48",
        "$49"
      ],

      name: "",

      alert: {
        status: false,
        color: "",
        message: ""
      }
    };
  },
  computed: {},
  methods: {
    clearRegionCMB() {
      this.validateRegion = "";
      this.regionModel = "";
    },
    clearZoneCMB() {
      this.validateZone = "";
      this.zoneModel = "";
      this.name = "";
    },
    clearDeliveryRateCMB() {
      this.validateDeliveryRate = "";
    },
    clearApplicableDateCMB() {
      this.validateApplicableDate = "";
      this.applicableDate = "";
    },
    clearDaysOfWeekCMB() {
      this.validateDaysOfWeek = "";
      this.daysOfWeekModel = { value: "1,2,3,4,5", label: "Weekdays" };
    },

    show() {
      this.$refs.modal.show();
    },
    provinceSelectedValue(event) {
      if (event !== null) {
        this.validateProvince = "";
      } else {
        this.validateProvince = "is-invalid";
      }
      this.clearRegionCMB();
      this.clearZoneCMB();
      this.clearApplicableDateCMB();
      this.$emit("changeProvince", event.value);
    },
    regionSelectedValue(event) {
      if (event !== null) {
        this.validateRegion = "";
      } else {
        this.validateRegion = "is-invalid";
      }
      this.clearZoneCMB();
      this.clearApplicableDateCMB();
      this.$emit("changeRegion", event.value);
    },
    zoneSelectedValue(event) {
      if (event !== null) {
        this.validateZone = "";
        this.name =
          (this.zoneModel.label || "") +
          " - " +
          this.displayText +
          " - " +
          this.rate;
      } else {
        this.validateZone = "is-invalid";
      }
    },
    deliveryRateSelectedValue(event) {
      if (event !== null) {
        this.validateDeliveryRate = "";
        this.name =
          (this.zoneModel.label || "") +
          " - " +
          this.displayText +
          " - " +
          this.rate;
      } else {
        this.validateDeliveryRate = "is-invalid";
      }
    },
    rateSelectedValue(event) {
      if (event !== null) {
        this.validateZone = "";
        this.name =
          (this.zoneModel.label || "") +
          " - " +
          this.displayText +
          " - " +
          this.rate;
      } else {
        this.validateZone = "is-invalid";
      }
    },
    applicableDateSelectedValue(event) {
      if (event !== null) {
        this.validateApplicableDate = "";
      } else {
        this.validateApplicableDate = "is-invalid";
      }
    },
    isSameDayOnlySelectedValue(event) {
      // No validation logic needed for this field currently
    },
    daysOfWeekSelectedValue(event) {
      if (event !== null) {
        this.validateDaysOfWeek = "";
      } else {
        this.validateDaysOfWeek = "is-invalid";
      }
    },
    validateProvinceCMB() {
      if (this.provinceModel !== null) {
        if (this.provinceModel.value == null) {
          this.validateProvince = "is-invalid";
        } else {
          this.validateProvince = "";
        }
      } else {
        this.validateProvince = "is-invalid";
      }
    },
    validateRegionCMB() {
      if (this.regionModel !== null) {
        if (this.regionModel.value == null) {
          this.validateRegion = "is-invalid";
        } else {
          this.validateRegion = "";
        }
      } else {
        this.validateRegion = "is-invalid";
      }
    },
    validateZoneCMB() {
      if (this.zoneModel) {
        if (this.zoneModel.value == null) {
          this.validateZone = "is-invalid";
        } else {
          this.validateZone = "";
        }
      } else {
        this.validateZone = "is-invalid";
      }
    },
    validateApplicableDateCMB() {
      if (this.applicableDateModel !== null) {
        if (this.applicableDateModel.value == null) {
          this.validateApplicableDate = "is-invalid";
        } else {
          this.validateApplicableDate = "";
        }
      } else {
        this.validateApplicableDate = "is-invalid";
      }
    },
    validateDaysOfWeekCMB() {
      if (this.daysOfWeekModel !== null) {
        if (this.daysOfWeekModel.value == null) {
          this.validateDaysOfWeek = "is-invalid";
        } else {
          this.validateDaysOfWeek = "";
        }
      } else {
        this.validateDaysOfWeek = "is-invalid";
      }
    },
    keyupValidationName() {
      if (this.name !== "") {
        this.validateName = true;
      } else {
        this.validateName = false;
      }
    },
    checkFormValidity() {
      const fullFormValidity = this.$refs.form.checkValidity();

      //validate name
      if (this.$refs.form.name.checkValidity()) {
        this.validateName = true;
      } else {
        this.validateName = false;
      }

      this.validateProvinceCMB();
      this.validateRegionCMB();
      this.validateZoneCMB();
      this.validateApplicableDateCMB();
      this.validateDaysOfWeekCMB();

      return fullFormValidity;
    },
    resetModal() {
      this.validateProvince = "";
      this.validateRegion = "";
      this.validateZone = "";
      this.validateApplicableDate = "";
      this.validateDaysOfWeek = "";
      this.name = "";
      this.validateName = null;
      this.daysOfWeekModel = { value: "1,2,3,4,5", label: "Weekdays" };
    },
    async handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      await this.handleSubmit();
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      try {
        if (!this.checkFormValidity()) {
          return null;
        }

        const zoneDeliveryRatePostArray = {
          name: this.name,
          zoneId: this.zoneModel.value,
          applicableStartTime: this.applicableStartTime,
          applicableEndTime: this.applicableEndTime,
          applicableDate: this.applicableDateModel.value,
          isSameDayOnly: this.isSameDayOnlyModel.value,
          displayText: this.displayText,
          rate: this.rate,
          daysOfWeek: this.daysOfWeekModel.value
        };

        const response = await this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_ADMIN_API_ENDPOINT}/rates/zone/rate`,
          headers: {
            Authorization: `Bearer ${this.$store.getters.idToken}`
          },
          data: zoneDeliveryRatePostArray
        });

        if (response.status == 201) {
          this.$nextTick(() => {
            this.hideModal("modal-add-zone-delivery-rate");
          });
          this.$emit("success", response.data["success"]);
        } else {
          this.$emit("error", response.data["error"]);
        }
      } catch (errorResponse) {
        this.$emit("error");
        console.error("Error: ", errorResponse);
      }
    }
  }
};
</script>
